/* The "Cargar más" row of the access log and the sentence of a further page that failed. */
.more {
  display: flex;
  margin-block-start: var(--space-4);
}

.moreFailed {
  margin: var(--space-4) 0 0;
  color: var(--danger-text);
}
